import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOKS_SHOW } from '../../constants/booksTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { bookSchema } from '../../schemas/Normalizr';

export function* booksShow(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params      = action.payload;

  try {
    yield *httpSaga(BOOKS_SHOW, call(booksAPI.show, params), bookSchema);
  } catch (e) {
    yield put(error(BOOKS_SHOW, e));
  } finally {
    yield put(doneIndicator(BOOKS_SHOW));
  }
}

export function* watchBooksShow() {
  yield takeEvery(BOOKS_SHOW, booksShow);
}

export default function* root() {
  yield all([
    fork(watchBooksShow)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/booksShow.js